/** Defines the default sorting for the document list, if there is no sorting given by the user */
export const defaultSort = "id:asc";
